/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductInfo } from './ProductInfo';
import {
    ProductInfoFromJSON,
    ProductInfoFromJSONTyped,
    ProductInfoToJSON,
    ProductInfoToJSONTyped,
} from './ProductInfo';
import type { CertificationsProductResponse } from './CertificationsProductResponse';
import {
    CertificationsProductResponseFromJSON,
    CertificationsProductResponseFromJSONTyped,
    CertificationsProductResponseToJSON,
    CertificationsProductResponseToJSONTyped,
} from './CertificationsProductResponse';

/**
 * 
 * @export
 * @interface LeadReqDTO
 */
export interface LeadReqDTO {
    /**
     * 
     */
    id?: number;
    /**
     * 
     */
    uuid?: string;
    /**
     * 
     */
    firebaseId?: string;
    /**
     * 
     */
    crmId?: string;
    /**
     * 
     */
    externalId?: string;
    /**
     * 
     */
    version?: string;
    /**
     * 
     */
    locale?: LeadReqDTOLocaleEnum;
    /**
     * 
     */
    partner?: string;
    /**
     * 
     */
    firstName?: string;
    /**
     * 
     */
    lastName?: string;
    /**
     * 
     */
    email?: string;
    /**
     * 
     */
    taxCode?: string;
    /**
     * 
     */
    phoneCountryCode?: string;
    /**
     * 
     */
    phoneNumber?: string;
    /**
     * 
     */
    hasItalianResidence?: boolean;
    /**
     * 
     */
    residenceProvince?: LeadReqDTOResidenceProvinceEnum;
    /**
     * 
     */
    residenceCityCode?: string;
    /**
     * 
     */
    residenceCityName?: string;
    /**
     * 
     */
    schoolFutureUuid?: string;
    /**
     * 
     */
    schoolFutureName?: string;
    /**
     * 
     */
    schoolFutureProvince?: LeadReqDTOSchoolFutureProvinceEnum;
    /**
     * 
     */
    schoolFutureTitle?: LeadReqDTOSchoolFutureTitleEnum;
    /**
     * 
     */
    schoolFutureTypology?: LeadReqDTOSchoolFutureTypologyEnum;
    /**
     * 
     */
    schoolLastTitle?: LeadReqDTOSchoolLastTitleEnum;
    /**
     * 
     */
    schoolFutureCityCode?: string;
    /**
     * 
     */
    schoolFutureCityName?: string;
    /**
     * 
     */
    schoolLastGrade?: number;
    /**
     * 
     */
    schoolLastGradeHasLaude?: boolean;
    /**
     * 
     */
    yearActual?: number;
    /**
     * 
     */
    consents?: Array<{ [key: string]: any | null; }>;
    /**
     * 
     */
    products?: Array<CertificationsProductResponse>;
    /**
     * 
     */
    productsAccessible?: Array<ProductInfo>;
    /**
     * 
     */
    numberMatchingProducts?: number;
    /**
     * 
     */
    utmId?: string;
    /**
     * 
     */
    utmSource?: string;
    /**
     * 
     */
    utmMedium?: string;
    /**
     * 
     */
    utmCampaign?: string;
    /**
     * 
     */
    utmTerm?: string;
    /**
     * 
     */
    utmContent?: string;
    /**
     * 
     */
    clid?: string;
    /**
     * 
     */
    clidType?: LeadReqDTOClidTypeEnum;
    /**
     * 
     */
    url?: string;
    /**
     * 
     */
    isTest?: boolean;
}


/**
 * @export
 */
export const LeadReqDTOLocaleEnum = {
    IT: 'IT',
    EN: 'EN',
} as const;
export type LeadReqDTOLocaleEnum = typeof LeadReqDTOLocaleEnum[keyof typeof LeadReqDTOLocaleEnum];

/**
 * @export
 */
export const LeadReqDTOResidenceProvinceEnum = {
    AG: 'AG',
    AL: 'AL',
    AN: 'AN',
    AO: 'AO',
    AR: 'AR',
    AP: 'AP',
    AT: 'AT',
    AV: 'AV',
    BA: 'BA',
    BT: 'BT',
    BL: 'BL',
    BN: 'BN',
    BG: 'BG',
    BI: 'BI',
    BO: 'BO',
    BZ: 'BZ',
    BS: 'BS',
    BR: 'BR',
    CA: 'CA',
    CL: 'CL',
    CB: 'CB',
    CE: 'CE',
    CT: 'CT',
    CZ: 'CZ',
    CH: 'CH',
    CO: 'CO',
    CS: 'CS',
    CR: 'CR',
    KR: 'KR',
    CN: 'CN',
    EN: 'EN',
    FM: 'FM',
    FE: 'FE',
    FI: 'FI',
    FG: 'FG',
    FC: 'FC',
    FR: 'FR',
    GE: 'GE',
    GO: 'GO',
    GR: 'GR',
    IM: 'IM',
    IS: 'IS',
    AQ: 'AQ',
    SP: 'SP',
    LT: 'LT',
    LE: 'LE',
    LC: 'LC',
    LI: 'LI',
    LO: 'LO',
    LU: 'LU',
    MC: 'MC',
    MN: 'MN',
    MS: 'MS',
    MT: 'MT',
    ME: 'ME',
    MI: 'MI',
    MO: 'MO',
    MB: 'MB',
    NA: 'NA',
    NO: 'NO',
    NU: 'NU',
    OR: 'OR',
    PD: 'PD',
    PA: 'PA',
    PR: 'PR',
    PV: 'PV',
    PG: 'PG',
    PU: 'PU',
    PE: 'PE',
    PC: 'PC',
    PI: 'PI',
    PT: 'PT',
    PN: 'PN',
    PZ: 'PZ',
    PO: 'PO',
    RG: 'RG',
    RA: 'RA',
    RC: 'RC',
    RE: 'RE',
    RI: 'RI',
    RN: 'RN',
    RM: 'RM',
    RO: 'RO',
    SA: 'SA',
    SS: 'SS',
    SV: 'SV',
    SI: 'SI',
    SR: 'SR',
    SO: 'SO',
    SU: 'SU',
    TA: 'TA',
    TE: 'TE',
    TR: 'TR',
    TO: 'TO',
    TP: 'TP',
    TN: 'TN',
    TV: 'TV',
    TS: 'TS',
    UD: 'UD',
    VA: 'VA',
    VE: 'VE',
    VB: 'VB',
    VC: 'VC',
    VR: 'VR',
    VV: 'VV',
    VI: 'VI',
    VT: 'VT',
} as const;
export type LeadReqDTOResidenceProvinceEnum = typeof LeadReqDTOResidenceProvinceEnum[keyof typeof LeadReqDTOResidenceProvinceEnum];

/**
 * @export
 */
export const LeadReqDTOSchoolFutureProvinceEnum = {
    AG: 'AG',
    AL: 'AL',
    AN: 'AN',
    AO: 'AO',
    AR: 'AR',
    AP: 'AP',
    AT: 'AT',
    AV: 'AV',
    BA: 'BA',
    BT: 'BT',
    BL: 'BL',
    BN: 'BN',
    BG: 'BG',
    BI: 'BI',
    BO: 'BO',
    BZ: 'BZ',
    BS: 'BS',
    BR: 'BR',
    CA: 'CA',
    CL: 'CL',
    CB: 'CB',
    CE: 'CE',
    CT: 'CT',
    CZ: 'CZ',
    CH: 'CH',
    CO: 'CO',
    CS: 'CS',
    CR: 'CR',
    KR: 'KR',
    CN: 'CN',
    EN: 'EN',
    FM: 'FM',
    FE: 'FE',
    FI: 'FI',
    FG: 'FG',
    FC: 'FC',
    FR: 'FR',
    GE: 'GE',
    GO: 'GO',
    GR: 'GR',
    IM: 'IM',
    IS: 'IS',
    AQ: 'AQ',
    SP: 'SP',
    LT: 'LT',
    LE: 'LE',
    LC: 'LC',
    LI: 'LI',
    LO: 'LO',
    LU: 'LU',
    MC: 'MC',
    MN: 'MN',
    MS: 'MS',
    MT: 'MT',
    ME: 'ME',
    MI: 'MI',
    MO: 'MO',
    MB: 'MB',
    NA: 'NA',
    NO: 'NO',
    NU: 'NU',
    OR: 'OR',
    PD: 'PD',
    PA: 'PA',
    PR: 'PR',
    PV: 'PV',
    PG: 'PG',
    PU: 'PU',
    PE: 'PE',
    PC: 'PC',
    PI: 'PI',
    PT: 'PT',
    PN: 'PN',
    PZ: 'PZ',
    PO: 'PO',
    RG: 'RG',
    RA: 'RA',
    RC: 'RC',
    RE: 'RE',
    RI: 'RI',
    RN: 'RN',
    RM: 'RM',
    RO: 'RO',
    SA: 'SA',
    SS: 'SS',
    SV: 'SV',
    SI: 'SI',
    SR: 'SR',
    SO: 'SO',
    SU: 'SU',
    TA: 'TA',
    TE: 'TE',
    TR: 'TR',
    TO: 'TO',
    TP: 'TP',
    TN: 'TN',
    TV: 'TV',
    TS: 'TS',
    UD: 'UD',
    VA: 'VA',
    VE: 'VE',
    VB: 'VB',
    VC: 'VC',
    VR: 'VR',
    VV: 'VV',
    VI: 'VI',
    VT: 'VT',
} as const;
export type LeadReqDTOSchoolFutureProvinceEnum = typeof LeadReqDTOSchoolFutureProvinceEnum[keyof typeof LeadReqDTOSchoolFutureProvinceEnum];

/**
 * @export
 */
export const LeadReqDTOSchoolFutureTitleEnum = {
    HS: 'HS',
    LT: 'LT',
    LM: 'LM',
    LMCU: 'LMCU',
    Master_I_Livello: 'Master-I-Livello',
    Master_II_Livello: 'Master-II-Livello',
    PhD: 'PhD',
    Scuola_Specializzazione: 'Scuola-Specializzazione',
    Erasmus: 'Erasmus',
    Laurea_Estero: 'Laurea Estero',
    Master_Estero: 'Master Estero',
    LMCUE: 'LMCUE',
    Corso_SSML: 'Corso SSML',
    Corso_AFAM: 'Corso AFAM',
    Corso_ITS: 'Corso ITS',
    Corso_Vocational: 'Corso Vocational',
    MBA: 'MBA',
    EMBA: 'EMBA',
    Prop_Pre_Master_E_Master_Estero: 'Prop Pre Master E Master Estero',
} as const;
export type LeadReqDTOSchoolFutureTitleEnum = typeof LeadReqDTOSchoolFutureTitleEnum[keyof typeof LeadReqDTOSchoolFutureTitleEnum];

/**
 * @export
 */
export const LeadReqDTOSchoolFutureTypologyEnum = {
    abroad_university: 'abroad_university',
    afam: 'afam',
    its: 'its',
    other: 'other',
    ssml: 'ssml',
    university: 'university',
    vocational: 'vocational',
} as const;
export type LeadReqDTOSchoolFutureTypologyEnum = typeof LeadReqDTOSchoolFutureTypologyEnum[keyof typeof LeadReqDTOSchoolFutureTypologyEnum];

/**
 * @export
 */
export const LeadReqDTOSchoolLastTitleEnum = {
    HS: 'HS',
    LT: 'LT',
    LM: 'LM',
    LMCU: 'LMCU',
    OTHER: 'OTHER',
} as const;
export type LeadReqDTOSchoolLastTitleEnum = typeof LeadReqDTOSchoolLastTitleEnum[keyof typeof LeadReqDTOSchoolLastTitleEnum];

/**
 * @export
 */
export const LeadReqDTOClidTypeEnum = {
    DCLID: 'DCLID',
    EF_ID: 'EF_ID',
    FBCLID: 'FBCLID',
    GCLID: 'GCLID',
    LI_FAT_ID: 'LI_FAT_ID',
    MC_EID: 'MC_EID',
    MSCLKID: 'MSCLKID',
    TTCLID: 'TTCLID',
    TWCLID: 'TWCLID',
    YCLID: 'YCLID',
} as const;
export type LeadReqDTOClidTypeEnum = typeof LeadReqDTOClidTypeEnum[keyof typeof LeadReqDTOClidTypeEnum];


/**
 * Check if a given object implements the LeadReqDTO interface.
 */
export function instanceOfLeadReqDTO(value: any): value is LeadReqDTO {
    return true;
}

export function LeadReqDTOFromJSON(json: any): LeadReqDTO {
    return LeadReqDTOFromJSONTyped(json, false);
}

export function LeadReqDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadReqDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'firebaseId': json['firebaseId'] == null ? undefined : json['firebaseId'],
        'crmId': json['crmId'] == null ? undefined : json['crmId'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'version': json['version'] == null ? undefined : json['version'],
        'locale': json['locale'] == null ? undefined : json['locale'],
        'partner': json['partner'] == null ? undefined : json['partner'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'taxCode': json['taxCode'] == null ? undefined : json['taxCode'],
        'phoneCountryCode': json['phoneCountryCode'] == null ? undefined : json['phoneCountryCode'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'hasItalianResidence': json['hasItalianResidence'] == null ? undefined : json['hasItalianResidence'],
        'residenceProvince': json['residenceProvince'] == null ? undefined : json['residenceProvince'],
        'residenceCityCode': json['residenceCityCode'] == null ? undefined : json['residenceCityCode'],
        'residenceCityName': json['residenceCityName'] == null ? undefined : json['residenceCityName'],
        'schoolFutureUuid': json['schoolFutureUuid'] == null ? undefined : json['schoolFutureUuid'],
        'schoolFutureName': json['schoolFutureName'] == null ? undefined : json['schoolFutureName'],
        'schoolFutureProvince': json['schoolFutureProvince'] == null ? undefined : json['schoolFutureProvince'],
        'schoolFutureTitle': json['schoolFutureTitle'] == null ? undefined : json['schoolFutureTitle'],
        'schoolFutureTypology': json['schoolFutureTypology'] == null ? undefined : json['schoolFutureTypology'],
        'schoolLastTitle': json['schoolLastTitle'] == null ? undefined : json['schoolLastTitle'],
        'schoolFutureCityCode': json['schoolFutureCityCode'] == null ? undefined : json['schoolFutureCityCode'],
        'schoolFutureCityName': json['schoolFutureCityName'] == null ? undefined : json['schoolFutureCityName'],
        'schoolLastGrade': json['schoolLastGrade'] == null ? undefined : json['schoolLastGrade'],
        'schoolLastGradeHasLaude': json['schoolLastGradeHasLaude'] == null ? undefined : json['schoolLastGradeHasLaude'],
        'yearActual': json['yearActual'] == null ? undefined : json['yearActual'],
        'consents': json['consents'] == null ? undefined : json['consents'],
        'products': json['products'] == null ? undefined : ((json['products'] as Array<any>).map(CertificationsProductResponseFromJSON)),
        'productsAccessible': json['productsAccessible'] == null ? undefined : ((json['productsAccessible'] as Array<any>).map(ProductInfoFromJSON)),
        'numberMatchingProducts': json['numberMatchingProducts'] == null ? undefined : json['numberMatchingProducts'],
        'utmId': json['utmId'] == null ? undefined : json['utmId'],
        'utmSource': json['utmSource'] == null ? undefined : json['utmSource'],
        'utmMedium': json['utmMedium'] == null ? undefined : json['utmMedium'],
        'utmCampaign': json['utmCampaign'] == null ? undefined : json['utmCampaign'],
        'utmTerm': json['utmTerm'] == null ? undefined : json['utmTerm'],
        'utmContent': json['utmContent'] == null ? undefined : json['utmContent'],
        'clid': json['clid'] == null ? undefined : json['clid'],
        'clidType': json['clidType'] == null ? undefined : json['clidType'],
        'url': json['url'] == null ? undefined : json['url'],
        'isTest': json['isTest'] == null ? undefined : json['isTest'],
    };
}

export function LeadReqDTOToJSON(json: any): LeadReqDTO {
    return LeadReqDTOToJSONTyped(json, false);
}

export function LeadReqDTOToJSONTyped(value?: LeadReqDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'uuid': value['uuid'],
        'firebaseId': value['firebaseId'],
        'crmId': value['crmId'],
        'externalId': value['externalId'],
        'version': value['version'],
        'locale': value['locale'],
        'partner': value['partner'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'taxCode': value['taxCode'],
        'phoneCountryCode': value['phoneCountryCode'],
        'phoneNumber': value['phoneNumber'],
        'hasItalianResidence': value['hasItalianResidence'],
        'residenceProvince': value['residenceProvince'],
        'residenceCityCode': value['residenceCityCode'],
        'residenceCityName': value['residenceCityName'],
        'schoolFutureUuid': value['schoolFutureUuid'],
        'schoolFutureName': value['schoolFutureName'],
        'schoolFutureProvince': value['schoolFutureProvince'],
        'schoolFutureTitle': value['schoolFutureTitle'],
        'schoolFutureTypology': value['schoolFutureTypology'],
        'schoolLastTitle': value['schoolLastTitle'],
        'schoolFutureCityCode': value['schoolFutureCityCode'],
        'schoolFutureCityName': value['schoolFutureCityName'],
        'schoolLastGrade': value['schoolLastGrade'],
        'schoolLastGradeHasLaude': value['schoolLastGradeHasLaude'],
        'yearActual': value['yearActual'],
        'consents': value['consents'],
        'products': value['products'] == null ? undefined : ((value['products'] as Array<any>).map(CertificationsProductResponseToJSON)),
        'productsAccessible': value['productsAccessible'] == null ? undefined : ((value['productsAccessible'] as Array<any>).map(ProductInfoToJSON)),
        'numberMatchingProducts': value['numberMatchingProducts'],
        'utmId': value['utmId'],
        'utmSource': value['utmSource'],
        'utmMedium': value['utmMedium'],
        'utmCampaign': value['utmCampaign'],
        'utmTerm': value['utmTerm'],
        'utmContent': value['utmContent'],
        'clid': value['clid'],
        'clidType': value['clidType'],
        'url': value['url'],
        'isTest': value['isTest'],
    };
}

